<template>
    <div>
        <loading v-if="loading"></loading>
        <vue-apex-charts v-if="!loading" type="bar" height="400" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>
    // import initFilterModel from '@/shared/filter';
    // import {formatDate, parseDate} from '@/shared/utils';
    import VueApexCharts from 'vue-apexcharts'
    import CurrencyFilter from '@/shared/filters/currency';
    import Loading from '@/views/Loading';


    // export const
    export default {
        name: "BarChartMonth",
        props: {
            data: Object,
            title: String,
            organizationType: String,
            province: Object,
        },
        components: {
            VueApexCharts,
            Loading
        },
        data() {
            return {
                loading: false,
                series: [
                    {
                        name: 'Хизмат хакки',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланмаган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                chartOptions: {
                    title: {
                        text: this.$props.title,//'Авто ва Асбоб-ускуналар (Ташкилотлар буйича)',
                        align: 'left',
                        offsetX: 110
                    },
                    tooltip: {
                        y: {
                            formatter: function(val) {
                                return CurrencyFilter(val, '', 2, { thousandsSeparator: ' ' });
                            },
                            title: {
                                formatter: function (seriesName) {
                                    return seriesName + ''
                                }
                            }
                        }
                        // custom: function ({series, /*seriesIndex, dataPointIndex, w*/}) {
                        //     return "<div>" + series + "</div>";
                        // }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'flat',
                            columnWidth: '50px',
                            barHeight: '50px',
                            distributed: false,
                            colors: {
                                ranges: [{
                                    from: 0,
                                    to: 0,
                                    color: undefined
                                }],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                            },
                            dataLabels: {
                                position: 'top',
                                maxItems: 100,
                                hideOverflowingLabels: true
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        offsetX: -6,
                        style: {
                            fontSize: '12px',
                            colors: ['#fff']
                        }
                    },
                    stroke: {
                        show: true,
                        width: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                        colors: ['#fff']
                    },

                    xaxis: {
                        categories: [
                            "Январь",
                            "Феврал",
                            "Март",
                            "Апрель",
                            "Май",
                            "Июнь",
                            "Июль",
                            "Август",
                            "Сентябрь",
                            "Октябрь",
                            "Ноябрь",
                            "Декабрь"
                            ],
                    },
                }
            }
        },
        methods: {
            initList() {

            }
        },
        created() {
            this.initList();

            this.$eventBus.$on('refreshBarChartMonth', (data) => {
                // console.log(data);
                this.chartOptions = {
                    title: {
                        text: data.barTitle,
                        align: 'left',
                        offsetX: 110
                    }
                };

            });
        },
        computed: {

        },
        watch: {
            data: function(newVal, /*oldVal*/) { // watch it
                if (newVal) {
                    const object = newVal;
                    // console.log(object);
                    const contractAmountTotal = object;//object.contractAmountTotal;
                    // console.log(this.$props.month);
                    // console.log(object);
                    this.loading = true;

                    if (this.$props.organizationType!=null && this.$props.province!=null) {
                        this.series = [
                            {
                                name: 'Хизмат хакки',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[0].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[1].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[2].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[3].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[4].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[5].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[6].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[7].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[8].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[9].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[10].contractAmount,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[11].contractAmount
                                ]
                            },
                            {
                                name: 'Туланган',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[0].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[1].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[2].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[3].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[4].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[5].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[6].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[7].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[8].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[9].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[10].paid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[11].paid
                                ]
                            },
                            {
                                name: 'Туланмаган',
                                type: 'column',
                                data: [
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[0].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[1].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[2].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[3].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[4].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[5].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[6].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[7].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[8].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[9].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[10].unpaid,
                                    contractAmountTotal[this.$props.organizationType].provinces[this.$props.province.code + ''].months[11].unpaid
                                ]
                            }
                        ];
                    } else { //by default
                        this.series = [
                            {
                                name: 'Хизмат хакки',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.months.length > 1 ? contractAmountTotal.ALL.months[0].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 2 ? contractAmountTotal.ALL.months[1].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 3 ? contractAmountTotal.ALL.months[2].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 4 ? contractAmountTotal.ALL.months[3].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 5 ? contractAmountTotal.ALL.months[4].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 6 ? contractAmountTotal.ALL.months[5].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 7 ? contractAmountTotal.ALL.months[6].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 8 ? contractAmountTotal.ALL.months[7].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 9 ? contractAmountTotal.ALL.months[8].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 10 ? contractAmountTotal.ALL.months[9].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 11 ? contractAmountTotal.ALL.months[10].contractAmount : 0,
                                    contractAmountTotal.ALL.months.length > 12 ? contractAmountTotal.ALL.months[11].contractAmount : 0
                                ]
                            },
                            {
                                name: 'Туланган',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.months.length > 1 ? contractAmountTotal.ALL.months[0].paid : 0,
                                    contractAmountTotal.ALL.months.length > 2 ? contractAmountTotal.ALL.months[1].paid : 0,
                                    contractAmountTotal.ALL.months.length > 3 ? contractAmountTotal.ALL.months[2].paid : 0,
                                    contractAmountTotal.ALL.months.length > 4 ? contractAmountTotal.ALL.months[3].paid : 0,
                                    contractAmountTotal.ALL.months.length > 5 ? contractAmountTotal.ALL.months[4].paid : 0,
                                    contractAmountTotal.ALL.months.length > 6 ? contractAmountTotal.ALL.months[5].paid : 0,
                                    contractAmountTotal.ALL.months.length > 7 ? contractAmountTotal.ALL.months[6].paid : 0,
                                    contractAmountTotal.ALL.months.length > 8 ? contractAmountTotal.ALL.months[7].paid : 0,
                                    contractAmountTotal.ALL.months.length > 9 ? contractAmountTotal.ALL.months[8].paid : 0,
                                    contractAmountTotal.ALL.months.length > 10 ? contractAmountTotal.ALL.months[9].paid : 0,
                                    contractAmountTotal.ALL.months.length > 11 ? contractAmountTotal.ALL.months[10].paid : 0,
                                    contractAmountTotal.ALL.months.length > 12 ? contractAmountTotal.ALL.months[11].paid : 0
                                ]
                            },
                            {
                                name: 'Туланмаган',
                                type: 'column',
                                data: [
                                    contractAmountTotal.ALL.months.length > 1 ? contractAmountTotal.ALL.months[0].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 2 ? contractAmountTotal.ALL.months[1].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 3 ? contractAmountTotal.ALL.months[2].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 4 ? contractAmountTotal.ALL.months[3].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 5 ? contractAmountTotal.ALL.months[4].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 6 ? contractAmountTotal.ALL.months[5].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 7 ? contractAmountTotal.ALL.months[6].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 8 ? contractAmountTotal.ALL.months[7].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 9 ? contractAmountTotal.ALL.months[8].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 10 ? contractAmountTotal.ALL.months[9].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 11 ? contractAmountTotal.ALL.months[10].unpaid : 0,
                                    contractAmountTotal.ALL.months.length > 12 ? contractAmountTotal.ALL.months[11].unpaid : 0
                                ]
                            }
                        ];
                    }
                    this.loading = false;

                    // this.series = [{
                    //     data: [
                    //         500, 55, 41, 64, 22, 43, 21
                    //     ]
                    // }];
                }

            }
        }
    }
</script>
<style>

</style>

